export default __webpack_public_path__ + "static/media/email-icon.33a4f0d8.svg";